/* Checkout-only products cleanup
 *
 * Some products (warranty, shipping protection, …) are injected into the cart
 * at checkout by a third-party app / Checkout UI extension. When the buyer
 * navigates back to the storefront we don't want those lines to persist, so
 * this script removes any cart line whose product is listed in the theme
 * setting "Checkout-only products" (window.theme.settings.checkoutOnlyProductIds).
 *
 * It's loaded on every page (when the feature is enabled) so it is also present
 * on a page restored from the back/forward cache — i.e. the page the buyer was
 * on *before* the product was added at checkout. To keep this cheap, the actual
 * `/cart.js` check only fires when there's a reason to:
 *   - `pageshow` with `event.persisted === true`  → bfcache restore, the classic
 *     "back from checkout" path (the page is stale, so we must re-check live).
 *   - a fresh load where the server already rendered the product into the cart
 *     (`window.__cartHasCheckoutOnly`) → covers abandoned-cart email / direct
 *     returns without fetching on ordinary browsing.
 *
 * After a removal it dispatches the standard `dispatch:cart-drawer:refresh`
 * event so both the cart drawer and the cart page re-render.
 */
(function () {
  function getCheckoutOnlyIds() {
    var ids = (window.theme && window.theme.settings && window.theme.settings.checkoutOnlyProductIds) || [];
    return new Set(ids.map(Number));
  }

  function refreshCartUI(cart) {
    var sideCart = document.querySelector('side-cart');
    var target = sideCart || document;
    target.dispatchEvent(
      new CustomEvent('dispatch:cart-drawer:refresh', {
        detail: { cart: cart },
        bubbles: true,
      })
    );
  }

  var purgeInFlight = false;

  async function purgeCheckoutOnlyProducts() {
    if (purgeInFlight) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var checkoutOnlyIds = getCheckoutOnlyIds();
    if (!checkoutOnlyIds.size) return;

    purgeInFlight = true;
    try {
      var cart = await fetch('/cart.js', { cache: 'no-store' }).then(function (r) {
        return r.json();
      });

      var updates = {};
      cart.items.forEach(function (item) {
        if (checkoutOnlyIds.has(Number(item.product_id))) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) return;

      var updatedCart = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates }),
      }).then(function (r) {
        return r.json();
      });

      refreshCartUI(updatedCart);
    } catch (err) {
      console.error('[checkout-only-products] purge failed:', err);
    } finally {
      purgeInFlight = false;
    }
  }

  function onPageShow(event) {
    // bfcache restore (back/forward) → page state is stale, always re-check.
    // Fresh load → only check if the server already rendered the product in.
    var shouldCheck = (event && event.persisted) || window.__cartHasCheckoutOnly === true;
    if (shouldCheck) purgeCheckoutOnlyProducts();
  }

  window.addEventListener('pageshow', onPageShow);
})();
